import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { mediaObjectContentStyles } from './styles/media-object-content.styles';
import type { MediaObjectContentPropsInterface } from './types/media-object-content.types';

/**
 * @since 10.0.0
 */
export const MediaObjectContent = forwardRef<HTMLDivElement, MediaObjectContentPropsInterface>(
  (props: MediaObjectContentPropsInterface, forwardedRef) => {
    const { asChild = false, className, css: cssProp, ...rest } = props;
    const styles = css(mediaObjectContentStyles, cssProp);
    const Component = asChild ? Slot : 'div';
    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="MediaObject.Content"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_media-object__content', styles, className)}
        {...rest}
      />
    );
  },
);

MediaObjectContent.displayName = 'MediaObject.Content';
